import PasswordInput from './PasswordInput'

export default PasswordInput
// eslint-disable-next-line import/export
export * from './PasswordInput'
